import * as actions from "./users.actions";
import * as types from "./users.actionTypes";
import { ActionType, createReducer } from "typesafe-actions";
import { UserReducerType } from "./types";

export type UserActions = ActionType<typeof actions>;

export const initialState: UserReducerType = {
  error: null,
  users: [],
  isLoading: false,
  createdUser: null,
  selectedUser: null
};

export const UserReducer = createReducer<
  UserReducerType,
  UserActions
>(initialState)
  .handleAction(actions.getUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.getUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    users: action.payload.data,
  }))
  .handleAction(actions.getUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.selectUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    createdUser: null,
    selectedUser: null,
    redirectQueue: ''
  }))
  .handleAction(actions.selectUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    selectedUser: action.payload.data,
  }))
  .handleAction(actions.selectUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.updateUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.updateUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdUser: action.payload.data,
  }))
  .handleAction(actions.updateUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(actions.createUserAsync.request, (state) => ({
    ...state,
    error: null,
    isLoading: true,
    redirectQueue: ''
  }))
  .handleAction(actions.createUserAsync.success, (state, action) => ({
    ...state,
    error: null,
    isLoading: false,
    createdUser: action.payload.data
  }))
  .handleAction(actions.createUserAsync.failure, (state, action) => ({
    ...state,
    isLoading: false,
    error: action.payload,
  }))
  .handleAction(types.SET_ERROR as any, (state, action) => ({
    ...state,
    error: action.payload.value
  }))
  .handleAction(types.RESET_STATE as any, (state, action) => ({
    ...state,
    error: null,
    createdUser: null,
    selectedUser: null
  }))
